import { SOURCES } from './sources.js';

// Sources for conflicting entries — both are flagged verificationNeeded
const AP_CONFLICT_SOURCES = [
  {
    ...SOURCES.crmsHome,
    note: 'CRMS homepage lists Erica Collier as 6th-grade AP.',
    verificationNeeded: true,
  },
  {
    ...SOURCES.crmsCampusInfo,
    note: 'Campus info page lists Leah Cox as 6th-grade AP. One name may be outdated — confirm at orientation.',
    verificationNeeded: true,
  },
];

const REGISTRAR_CONFLICT_SOURCES = [
  {
    ...SOURCES.crmsCounseling,
    note: 'CRMS Counseling site lists Conner Carlow as registrar.',
    verificationNeeded: true,
  },
  {
    ...SOURCES.crmsRegistrar,
    note: 'Earlier records reference Jenni Carroll. Staff may have changed — confirm at orientation.',
    verificationNeeded: true,
  },
];

export const PEOPLE = [
  // ── Leadership ──────────────────────────────────────────────────────────
  {
    id: 'wendy-sturdevant',
    name: 'Wendy Sturdevant',
    title: 'Principal',
    email: 'wendy.sturdevant@leanderisd.org',
    phone: '512-570-3500',
    gradeLevel: null,
    responsibility: 'Overall school leadership',
    forStudent: ['general'],
    group: 'leadership',
    source: SOURCES.crmsCampusInfo,
    verificationNeeded: false,
  },
  {
    id: 'erica-collier',
    name: 'Erica Collier',
    title: '6th Grade Assistant Principal',
    email: 'erica.collier@leanderisd.org',
    phone: '512-570-3500',
    gradeLevel: 6,
    responsibility: '6th grade discipline and student affairs',
    forStudent: ['discipline', 'general'],
    group: 'leadership',
    sources: AP_CONFLICT_SOURCES,
    verificationNeeded: true,
  },
  {
    id: 'leah-cox',
    name: 'Leah Cox',
    title: '6th Grade Assistant Principal',
    email: null,
    phone: '512-570-3500',
    gradeLevel: 6,
    responsibility: '6th grade discipline and student affairs',
    forStudent: ['discipline', 'general'],
    group: 'leadership',
    sources: AP_CONFLICT_SOURCES,
    verificationNeeded: true,
  },
  {
    id: 'brian-bass',
    name: 'Brian Bass',
    title: '7th Grade Assistant Principal',
    email: 'charles.bass@leanderisd.org',
    phone: '512-570-3500',
    gradeLevel: 7,
    responsibility: '7th grade discipline and student affairs',
    forStudent: ['discipline', 'general'],
    group: 'leadership',
    source: SOURCES.crmsCampusInfo,
    verificationNeeded: false,
  },
  {
    id: 'ashley-thompson',
    name: 'Dr. Ashley Thompson',
    title: '8th Grade Assistant Principal',
    email: 'ashley.thompson1@leanderisd.org',
    phone: '512-570-3500',
    gradeLevel: 8,
    responsibility: '8th grade discipline and student affairs',
    forStudent: ['discipline', 'general'],
    group: 'leadership',
    source: SOURCES.crmsCampusInfo,
    verificationNeeded: false,
  },

  // ── Counselors ───────────────────────────────────────────────────────────
  {
    id: 'staci-cote',
    name: 'Staci Cote',
    title: 'School Counselor',
    email: null,
    phone: null,
    gradeLevel: null,
    responsibility: '6th grade (all) · 7th grade last names J–Z',
    forStudent: ['academic', 'emotional', 'general'],
    group: 'counselors',
    source: SOURCES.crmsCounseling,
    verificationNeeded: false,
  },
  {
    id: 'kimberly-mills',
    name: 'Kimberly Mills',
    title: 'School Counselor',
    email: null,
    phone: null,
    gradeLevel: null,
    responsibility: '8th grade (all) · 7th grade last names A–I',
    forStudent: ['academic', 'emotional', 'general'],
    group: 'counselors',
    source: SOURCES.crmsCounseling,
    verificationNeeded: false,
  },
  {
    id: 'cheryl-kleffner',
    name: 'Cheryl Kleffner',
    title: 'Counseling Admin Assistant',
    email: null,
    phone: null,
    gradeLevel: null,
    responsibility: 'Counseling office admin',
    forStudent: ['general'],
    group: 'counselors',
    source: SOURCES.crmsCounseling,
    verificationNeeded: false,
  },

  // ── Support Staff ────────────────────────────────────────────────────────
  {
    id: 'megan-prata',
    name: 'Megan Prata',
    title: 'Admin Asst to Principal',
    email: null,
    phone: '512-570-3500',
    gradeLevel: null,
    responsibility: "Principal's office; contact for orientation questions",
    forStudent: ['general'],
    group: 'support',
    source: SOURCES.crmsCampusInfo,
    verificationNeeded: false,
  },
  {
    id: 'conner-carlow',
    name: 'Conner Carlow',
    title: 'Registrar',
    email: null,
    phone: '512-570-3515',
    gradeLevel: null,
    responsibility: 'Enrollment, transcripts, records',
    forStudent: ['records'],
    group: 'support',
    sources: REGISTRAR_CONFLICT_SOURCES,
    verificationNeeded: true,
  },
  {
    id: 'jenni-carroll',
    name: 'Jenni Carroll',
    title: 'Registrar',
    email: null,
    phone: '512-570-3515',
    gradeLevel: null,
    responsibility: 'Enrollment, transcripts, records',
    forStudent: ['records'],
    group: 'support',
    sources: REGISTRAR_CONFLICT_SOURCES,
    verificationNeeded: true,
  },
  {
    id: 'larissa-baggett',
    name: 'Larissa Baggett',
    title: '504 Coordinator',
    email: null,
    phone: '512-570-3500',
    gradeLevel: null,
    responsibility: '504 accommodation plans',
    forStudent: ['504'],
    group: 'support',
    source: {
      ...SOURCES.crmsCampusInfo,
      note: 'Name per parent records; not independently confirmed on public CRMS site. Verify at orientation.',
      verificationNeeded: true,
    },
    verificationNeeded: true,
  },
];

export const CONTACT_BY_ISSUE = [
  {
    id: 'sick-leaving',
    issue: 'Child is sick or leaving early',
    contact: 'Attendance Office',
    phone: '512-570-3514',
    email: 'crmsattendance@leanderisd.org',
    url: SOURCES.crmsAttendance.url,
  },
  {
    id: 'health-nurse',
    issue: 'Health / nurse / medications',
    contact: 'Clinic / Nurse',
    phone: '512-570-3507',
    email: null,
    url: null,
  },
  {
    id: 'counseling-courses',
    issue: 'Counseling / course selection / GT',
    contact: 'Counseling Office',
    phone: null,
    email: 'counseling@leanderisd.org',
    url: SOURCES.crmsCounseling.url,
  },
  {
    id: 'enrollment-records',
    issue: 'New enrollment / transcripts / records',
    contact: 'Registrar',
    phone: '512-570-3515',
    email: null,
    url: SOURCES.crmsRegistrar.url,
  },
  {
    id: 'bus-smarttag',
    issue: 'Bus / SMART Tag',
    contact: 'Transportation',
    phone: '512-570-0700',
    email: null,
    url: SOURCES.smartTagPortal.url,
  },
  {
    id: 'meal-account',
    issue: 'Meal account / MySchoolBucks',
    contact: 'Child Nutrition',
    phone: '512-570-0670',
    email: null,
    url: SOURCES.childNutrition.url,
  },
  {
    id: 'tech-support',
    issue: 'Tech support / Chromebook / mLISD',
    contact: 'Help Desk',
    phone: '512-570-0566',
    email: null,
    url: 'https://leanderisd.incidentiq.com',
  },
  {
    id: 'general',
    issue: 'General / front office',
    contact: 'CRMS Main Office',
    phone: '512-570-3500',
    email: null,
    url: SOURCES.crmsHome.url,
  },
];

export default PEOPLE;
